export var DocumentsType;
(function (DocumentsType) {
    DocumentsType["diadoc"] = "DIADOC";
    DocumentsType["email"] = "EMAIL";
    DocumentsType["personal"] = "PERSONAL";
})(DocumentsType || (DocumentsType = {}));
